/* 🤖 this file was generated by script */
export const wsolidiconAlertTriangle = {
  name: 'alert_triangle',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.81 1.67a2 2 0 0 0-1.62 0c-.4.18-.66.49-.84.74q-.27.39-.58.94L1.5 17.63q-.32.56-.53.98a2 2 0 0 0-.22 1.1 2 2 0 0 0 .8 1.4c.36.27.76.33 1.08.36q.46.04 1.1.03h16.54q.64 0 1.1-.03c.32-.03.72-.1 1.07-.35a2 2 0 0 0 .81-1.41 2 2 0 0 0-.22-1.1q-.2-.42-.53-.98L14.23 3.35q-.31-.55-.58-.94a2 2 0 0 0-.84-.74M13 9a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
